import moment from 'moment';
const notificationType = {
    TIMESHEET: 0,
    ALLOCATION: 1,
    LEAVE: 2,
    PAYROLL: 3,
    USER: 4,
    OTHERS: 5
};

const workingHours = {
    HOURS: "14:00",
};

const submitFutureDateTimesheet = {
    DATE: 25,
}

const currencies = [
    { name: 'AUD', code: 'AUD', country: 'AUS' },
    { name: 'CAD', code: 'CAD', country: 'CAN' },
    { name: 'INR', code: 'INR', country: 'IND' },
    { name: 'SGD', code: 'SGD', country: 'SIN' },
    { name: 'GBP', code: 'GBP', country: 'UK' },
    { name: 'USD', code: 'USD', country: 'USA' },
    { name: 'PH', code: 'PH', country: 'PHL' }
];

const regularizationReason = {
    MARKOUT_FORGOT: "Forgot to mark In/Out",
    REFILL_ATTENDANCE: "Refill Attendance",
};

const LeaveStatus = {
    DRAFT: 0,
    REVIEW: 1,
    APPROVED: 2,
    REJECTED: 3
}

const LeaveStatusCode = {
    0: 'DRAFT',
    1: 'REVIEW',
    2: 'APPROVED',
    3: 'REJECTED'
}

const Status = {
    INACTIVE: 0,
    ACTIVE: 1,
    REJECT: 2,
    UPCOMING: 3,
    ARCHIVE: 4,
}

const TravelStatus = {
    SUBMITTED_TO_APPROVER: 1,
    APPROVED_BY_MANAGER: 2,
    REJECTED_BY_MANAGER: 3,
    APPROVED_BY_BU_HEAD: 4,
    REJECTED_BY_BU_HEAD: 5,
    APPROVED_BY_HR_HEAD: 6,
    REJECTED_BY_HR_HEAD: 7,
    APPROVED_BY_CEO: 8,
    REJECTED_BY_CEO: 9,
}

const DescLength = {
    DESCRIPTION: 20,
    MAX_LENGTH: 150
}

const typeOfTraining = [
    { label: "Self-Paced", value: "Self-Paced" },
    { label: "Instructor-Led", value: "Instructor-Led" },
];

const projectStatusOfResource = [
    { id: 1, title: 'Billable', status: 1 },
    { id: 2, title: 'Non-Billable', status: 1 },
];

const trainingStatusList = [
    { "id": 0, "title": "Not Started" },
    { "id": 1, "title": "In Progress" },
    { "id": 2, "title": "Completed" },
];

const calcEndDate = {
    ESUK: {
        ML: (start) => { return moment(start).add(26, 'weeks') },
        ADL: (start) => { return moment(start).add(26, 'weeks') },
        BL: (start) => { return moment(start).add(2, 'weeks') },
        PBL: (start) => { return moment(start).add(2, 'weeks') },
        PAL: (start) => { return moment(start).add(18, 'weeks') },
        PL: (start) => { return moment(start).add(2, 'weeks') },
    }
}

export {
    notificationType, workingHours, regularizationReason, LeaveStatus, Status, DescLength, LeaveStatusCode, calcEndDate,
    TravelStatus, currencies, submitFutureDateTimesheet, typeOfTraining, projectStatusOfResource, trainingStatusList
}
